import L from 'leaflet';

const icon = (type: string) => {
    let iconUrl = './img/black-marker.svg';
    if (type === 'pendiente') {
        iconUrl = './img/pendiente-marker.svg';
    } else if (type === 'rechazado') {
        iconUrl = './img/rechazado-marker.svg';
    } else if (type === 'parcial') {
        iconUrl = './img/parcial-marker.svg';
    } else if (type === 'aceptado') {
        iconUrl = './img/aceptado-marker.svg';
    } else if (type === 'aceptable') {
        iconUrl = './img/aceptable-marker.svg';
    } else if (type === 'regular') {
        iconUrl = './img/regular-marker.svg';
    } else if (type === 'deficiente') {
        iconUrl = './img/deficiente-marker.svg';
    } else if (type === 'camion') {
        iconUrl = './img/camion-marker.svg';
    }
    return new L.Icon({
        iconUrl: require(`${iconUrl}`),
        iconRetinaUrl: require(`${iconUrl}`),
        iconSize: new L.Point(35, 50),
        popupAnchor: [0, -26],
        iconAnchor: [17, 35],
    });
};

const camionIcon = new L.Icon({
    iconUrl: require('./img/camion-marker.svg'),
    iconRetinaUrl: require('./img/camion-marker.svg'),
    iconSize: new L.Point(25, 40),
    iconAnchor: [14, 18],
});

const divIcon = (html: string, className: string, iconAnchor) => {
    return new L.DivIcon({
        className,
        html,
        iconAnchor,
    })
};

export {icon, divIcon, camionIcon};


// WEBPACK FOOTER //
// ./src/components/common/icon.ts